export default __webpack_public_path__ + "static/media/profile.96dbfdd5.svg";